import axios from 'axios'
import { Message } from 'element-ui'
import {showLoadingSpinner,hideLoadingSpinner} from './loading.js'
import store from '@/store'
// create an axios instance
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
const service = axios.create({
  baseURL: '/apiip',// url = base url + request url
  timeout: 86400000
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['userToken'] = store.getters.token
    }
    showLoadingSpinner()
    return config
  },
  error => {
    hideLoadingSpinner()
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    if ((response?.data?.code ? response?.data?.code : response?.data[0]?.code) != 200) {
      hideLoadingSpinner()
      return Promise.resolve(response.data)
    }
    hideLoadingSpinner()
    return Promise.resolve(response.data)
  },
  error => {
    Message({
      dangerouslyUseHTMLString: true,
      message: error.response?.data?.message || '请求失败',
      type: 'error',
      duration: 5 * 1000
    })
    hideLoadingSpinner()
    return Promise.reject(error.response?.data)
  }
)

export default service
